import { defineStore } from 'pinia'
import { ref } from 'vue'

const initState = { nickname: '', avatar: '' }

export const useUserStore = defineStore(
  'user',
  () => {
    const userInfo = ref({ ...initState })
    const token = ref('')
    const currentPhone = ref('86')
    const currentPassengersPhone = ref('中国 +86')
    const redirect = ref('')
    const expire = ref('')
    const bankChannel = ref('')
    // 是否从第三方进入
    const isThird = ref(false)
    const payInfo = ref('')
    const setUserInfo = (val) => {
      userInfo.value = val
    }
    const setRedirect = (val) => {
      redirect.value = val
    }
    const setToken = (val) => {
      token.value = val
    }
    const setExpire = (val) => {
      expire.value = val
    }
    const clear = () => {
      userInfo.value = {}
      token.value = ''
      redirect.value = ''
      expire.value = ''
    }
    const setPhone = (val) => {
      currentPhone.value = val
    }
    const setPassengersPhone = (val) => {
      currentPassengersPhone.value = val
    }
    const clearUserInfo = () => {
      userInfo.value = { ...initState }
    }
    // 一般没有reset需求，不需要的可以删除
    const reset = () => {
      userInfo.value = { ...initState }
    }
    const setIsThird = (val) => {
      isThird.value = val
    }
    const isLogined = computed(() => !!userInfo.value.token)
    const setBankChannel = (val) => {
      bankChannel.value = val
    }
    const setPayInfo = (val) => {
      payInfo.value = val
    }
    return {
      userInfo,
      currentPhone,
      currentPassengersPhone,
      setPassengersPhone,
      setPhone,
      setUserInfo,
      clearUserInfo,
      isLogined,
      reset,
      setToken,
      token,
      redirect,
      setRedirect,
      clear,
      setExpire,
      expire,
      isThird,
      setIsThird,
      bankChannel,
      setBankChannel,
      payInfo,
      setPayInfo,
    }
  },
  {
    persist: true,
  },
)
